import type { SVGProps } from 'react'

export const BrandOverviewIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="22" height="22" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.1399 10.5933C13.7158 11.5963 13.0525 12.4801 12.2079 13.1675C11.3633 13.8549 10.3631 14.3249 9.2949 14.5365C8.22668 14.7481 7.12289 14.6947 6.08004 14.3812C5.03719 14.0676 4.08703 13.5034 3.31262 12.7377C2.53822 11.9721 1.96315 11.0285 1.6377 9.98927C1.31225 8.95007 1.24632 7.84696 1.44568 6.77639C1.64503 5.70582 2.10361 4.70039 2.78131 3.84799C3.45901 2.99559 4.3352 2.32218 5.33328 1.88664M14.6667 7.99992C14.6667 7.12444 14.4942 6.25753 14.1592 5.4487C13.8242 4.63986 13.3331 3.90493 12.714 3.28587C12.095 2.66682 11.3601 2.17575 10.5512 1.84072C9.74239 1.50569 8.87548 1.33325 8 1.33325V7.99992H14.6667Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
